import { ReactNode } from 'react';

export interface HeaderProps {
  children: ReactNode;
}

export default function Header({ children }: HeaderProps) {
  return <div className="flex flex-row flex-shrink px-4 py-2">{children}</div>;
}
